import { TextInput } from "./text-input.js";
import { styles as TextInputStyles } from "./text-input.styles";
import { template as TextInputTemplate } from "./text-input.template";
import { DesignSystem } from "../design-system";
/**
 * The Fabric Text Input component.
 *
 * @public
 */
export const definition = TextInput.compose({
    name: `${DesignSystem.prefix}-text-input`,
    template: TextInputTemplate,
    styles: TextInputStyles,
    shadowOptions: {
        mode: DesignSystem.shadowRootMode
    }
});
//# sourceMappingURL=text-input.definition.js.map